module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-8bac7693479c7c60c72a301606f35c46.png";